export default "__VITE_ASSET__BuToMhjk__"